<template>
  <div
    class="page-content relative"
    id="ap-library"
    :class="{ 'no-chrome': !Ichrome }"
  >
    <Titlebar :incrustation="'beepiz-aplibrary'" v-if="Ichrome">
      <h1>{{ $t("ap.titles.library") }}</h1>
    </Titlebar>
    <div>
      <div class="row">
        <div :class="libraryClasses" v-if="!editMode">
          <UiCard>
            <div class="row">
              <div class="col" v-show="!Ichrome">
                <h2 class="text-xl font-semibold m-0">
                  {{ $t("ap.titles.librarylist") }}
                </h2>
              </div>
              <div class="col flex gap-2">
                <FilterField
                  @filter="handleFilter"
                  class="with-type-filters flex-1"
                ></FilterField>
                <div class="type-filters">
                  <i
                    v-for="(apType, key) in icons"
                    :key="key"
                    :class="[apType, { disabled: !filter[key] }]"
                    @click.stop="handleTypeFilter(key)"
                  >
                  </i>
                </div>
              </div>
            </div>
            <div v-if="isLoading" class="py-5 flex justify-center">
              <UiSpinner />
            </div>
            <div
              v-else-if="actionpoints.length == 0"
              class="py-5 center text-center"
            >
              {{ $t("global.no_results") }}
            </div>
            <div v-else>
              <APList
                ref="aplist"
                :list="actionpoints"
                @apSelect="handleSelect"
                @apUnselect="handleUnselect"
                :multiselect="!Ichrome && multiselect"
                :chrome="chrome"
                @next="handleNextPage"
              />              
            </div>
            <div class="row">
                <div class="col center">
                  <UiPagination ref="pagination" @change="handlePagination" />
                </div>
              </div>
          </UiCard>
        </div>
        <div class="col" v-if="useDvFlagAccess('beepiz-action-point-can:create')">
          <LoadingMini ref="loading"></LoadingMini>
          <UiCard>
            <APForm ref="apForm" @saved="handleSave" @error="onError"></APForm>
          </UiCard>
          <Toolbar v-if="Ichrome" class="mt-3 justify-content-end sticky top-2">
            <Btn
                v-if="useDvFlagAccess('beepiz-action-point-can:delete')"
              class="default"
              :class="{ disabled: !isDeletable }"
              :disabled="!isDeletable"
              @click.native.stop="deleteAP"
              v-can="'beepiz-delete-library'"
            >
              <span>{{ $t("global.delete") }}</span>
            </Btn>
            <Btn
                v-if="useDvFlagAccess('beepiz-action-point-can:create')"
              class="primary"
              @click.native.stop="validForm"
              v-can="canBtnSave"
            >
              <span>{{ labelBtnSave }}</span>
            </Btn>
          </Toolbar>
        </div>
      </div>
    </div>
    <div class="toolbar-ghost"></div>
    <Toolbar
      v-if="!Ichrome"
      class="fixed bottom left right z-10 p-3 px-4 justify-content-end bg-white border-top"
    >
      <Btn @click.native.stop="cancelAP">
        <span>{{ $t("global.cancel") }}</span>
      </Btn>
      <Btn class="primary" @click.native.stop="validFormOrSelect">
        <span>{{ labelButton }}</span>
      </Btn>
    </Toolbar>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/services/API";

import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import UiCard from "@/components/ui/Card";

import APForm from "@/views/actionpoints/library/Form";
import APList from "@/views/actionpoints/library/List";
import FilterField from "@/components/ui/Filter";

import Icons from "@/services/iconMapping.js";

import LoadingMini from "@/components/ui/LoadingMini";
import UiSpinner from "@/components/ui/UiSpinner";

import Utils from "@/services/utils.js";

import findIndex from "lodash/findIndex";
import UiPagination from "@/components/ui/Pagination";
import { action } from "@storybook/addon-actions";
import {useDvFlag, useDvFlagAccess} from "../../../services/featureFlag";

export default {
  components: {
    Titlebar,
    Toolbar,
    Btn,
    UiPagination,
    UiCard,
    APForm,
    APList,
    FilterField,
    LoadingMini,
    UiSpinner,
  },
  computed: {
    labelBtnSave: function () {
      if (this.selectedAp) {
        return window.V.$i18n.t("global.edit");
      } else {
        return window.V.$i18n.t("global.add");
      }
    },
    canBtnSave: function () {
      if (this.selectedAp) {
        return "beepiz-edit-library";
      } else {
        return "beepiz-add-library";
      }
    },
    icons: function () {
      return Icons.filters;
    },
    isDeletable: function () {
      if (this.selectedAp) {
        if (
          this.selectedAp.patrols != null &&
          this.selectedAp.patrols.length > 0
        ) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    },
  },
  data() {
    return {
      isBusy: false,
      isLoading: true,
      editMode: false,
      selectedAp: null,
      filter: {
        q: "",
        wifi: this.patrol ? false : true,
        beacon: this.patrol ? false : true,
        nfc: true,
        qrcode: true,
      },
      currentPage: 1,
      totalPage: 1,
      labelButton: "",
      optionsList: {},
      Ichrome: true,
      libraryClasses: useDvFlagAccess('beepiz-action-point-can:create')?"col-8":"col-12",
      actionpoints: [],
      multiselect: true,
    };
  },
  methods: {
    useDvFlagAccess,
    handlePagination(page) {
      this.actionpoints = [];
      this.loadList(page);
    },
    cancelAP: function () {
      this.unselectAll();
      this.$emit("cancelAP");
    },
    validForm: function () {
      if (!this.isBusy) {
        if (this.$refs.loading) {
          this.$refs.loading.show();
        }
        this.isBusy = true;
        if (this.$refs.apForm) {
          this.$refs.apForm.validateForm();
        }
      }
    },
    validFormOrSelect: function () {
      //si le formulaire est rempli
      if (this.$refs.apForm && this.$refs.apForm.hasModifications()) {
        if (!this.isBusy) {
          if (this.$refs.loading) {
            this.$refs.loading.show();
          }
          this.isBusy = true;
          this.$refs.apForm.validateForm();
        }
      } else {
        // si le formulaire n'est pas rempli
        // on ajoute les ap selectionnés au plan
        var tabSelected = [];
        this.actionpoints.forEach(function (obj, idx) {
          if (obj.selected) {
            tabSelected.push(obj);
          }
        });
        this.$emit("selectAP", tabSelected);
        this.unselectAll();
      }
    },
    loadList: function (page) {
      this.isLoading = true;
      this.optionsList.perpage = 48;
      this.optionsList.sort = ["+name"];
      if (page != null) {
        this.optionsList.page = page;
        if (page == 1 && this.$refs.aplist) {
          this.$refs.aplist.scrollToTop();
        }
      }
      this.optionsList.filter = {};
      this.optionsList.type = [];
      if (this.filter.q != "") {
        this.optionsList.filter.like = ["name:" + this.filter.q];
      }
      if (
        !this.filter.wifi ||
        !this.filter.beacon ||
        !this.filter.nfc ||
        !this.filter.qrcode
      ) {
        if (this.filter.wifi) {
          this.optionsList.type.push(1);
        }
        if (this.filter.beacon) {
          this.optionsList.type.push(2);
          this.optionsList.type.push(5);
        }
        if (this.filter.nfc) {
          this.optionsList.type.push(3);
        }
        if (this.filter.qrcode) {
          this.optionsList.type.push(4);
        }
      }
      var endpoint = API.endpoints.actionpoints.index;
      if (!this.chrome) {
        if (this.patrol !== true) {
          if (this.planId == null) {
            return;
          }
          endpoint = API.route(API.endpoints.plans.apAvailable, {
            planId: this.planId,
          });
        }
      }
      axios
        .get(endpoint + API.constructQueryParams(this.optionsList))
        .then((response) => {
          this.isBusy = false;
          this.isLoading = false;
          this.totalPage = response.data.meta.pagination.total_pages;
          this.currentPage = response.data.meta.pagination.current_page;
          if (this.$refs.pagination) {
            this.$refs.pagination.update(response.data.meta.pagination);
          }
          if (this.currentPage == 1) {
            this.actionpoints = response.data.data;
          } else {
            this.actionpoints.push.apply(this.actionpoints, response.data.data);
          }
          if (this.Ichrome) {
            window.Vfc.$refs.loading.hide();
          }
          this.$nextTick(() => {
            if (this.$refs.aplist) {
              this.$refs.aplist.unlockScroll();
            }
          });
          if (this.$refs.loading) {
            this.$refs.loading.hide();
          }
        });
    },
    onError: function () {
      this.isBusy = false;
      if (this.$refs.loading) {
        this.$refs.loading.hide();
      }
    },
    handleSave: function (id) {
      var vThis = this;
      this.loadList(1);
      if (id != null) {
        axios
          .get(API.route(API.endpoints.actionpoints.show, { apId: id }))
          .then((response) => {
            vThis.$emit("selectAP", [response.data]);
          });
      } else {
        this.selectedAp = null;
      }
    },
    handleSelect: function (ap) {
      if (this.Ichrome) {
        this.selectedAp = ap;
        if (this.$refs.apForm) {
          this.$refs.apForm.populateForm(ap);
        }
      } else {
      }
    },
    handleUnselect: function (ap) {
      if (this.Ichrome) {
        this.selectedAp = null;
        this.labelButton = window.V.$i18n.t("global.add");
        if (this.$refs.apForm) {
          this.$refs.apForm.resetForm();
        }
      }
    },
    unselectAll: function () {
      if (this.$refs.aplist) {
        this.$refs.aplist.unselectAll();
      }
    },
    deleteAP: function () {
      var vThis = this;

      var content = Utils.t("ap.library.actions.delete.content1");
      if (vThis.selectedAp.plans != null && vThis.selectedAp.plans.length > 0) {
        content = Utils.t("ap.library.actions.delete.content2") + content;
      }
      window.Vfc.$refs.confirm.show({
        title: Utils.t("ap.library.actions.delete.modalTitle"),
        content: content,
        callbackYes: function () {
          if (vThis.$refs.loading) {
            vThis.$refs.loading.show();
          }
          axios
            .delete(
              API.route(API.endpoints.actionpoints.delete, {
                apId: vThis.selectedAp.id,
              }),
              vThis.selectedAp
            )
            .then((response) => {
              if (vThis.$refs.apForm) {
                vThis.$refs.apForm.resetForm();
              }
              var index = findIndex(vThis.actionpoints, function (item) {
                return item.id == vThis.selectedAp.id;
              });
              vThis.actionpoints.splice(index, 1);
              if (vThis.$refs.loading) {
                vThis.$refs.loading.hide();
              }
              window.Vfc.$refs.messages.sendMessage(
                "success",
                Utils.t("ap.library.actions.delete.success")
              );
            })
            .catch((error) => {
              if (vThis.$refs.loading) {
                vThis.$refs.loading.hide();
              }
            });
        },
      });
    },
    handleFilter: function (filter) {
      this.filter.q = filter;
      this.loadList(1);
    },
    handleTypeFilter: function (type) {
      if (this.patrol && (type === "wifi" || type === "beacon")) {
        this.filter[type] = false;
      } else {
        this.filter[type] = !this.filter[type];
        this.loadList(1);
      }
    },
    handleNextPage: function () {
      if (this.currentPage < this.totalPage) {
        this.loadList(this.currentPage + 1);
      } else {
        if (this.$refs.aplist) {
          this.$refs.aplist.unlockScroll();
        }
      }
    },
    edit: function (node, multiselect, typeFilter) {
      if (multiselect === false) {
        this.multiselect = false;
      } else {
        this.multiselect = true;
      }
      if (typeFilter != null) {
        this.filter.wifi = false;
        this.filter.beacon = false;
        this.filter.nfc = false;
        this.filter.qrcode = false;

        if (typeFilter.indexOf(1) != -1) {
          this.filter.wifi = true;
        }
        if (typeFilter.indexOf(2) != -1) {
          this.filter.beacon = true;
        }
        if (typeFilter.indexOf(3) != -1) {
          this.filter.nfc = true;
        }
        if (typeFilter.indexOf(4) != -1) {
          this.filter.qrcode = true;
        }
        if (typeFilter.indexOf(5) != -1) {
          this.filter.beacon = true;
        }
      } else {
        this.filter.wifi = !this.patrol;
        this.filter.beacon = !this.patrol;
        this.filter.nfc = true;
        this.filter.qrcode = true;
      }
      if (node == null) {
        this.editMode = false;
        this.labelButton = window.V.$i18n.t("global.add");
        if (this.$refs.apForm) {
          this.$refs.apForm.resetForm();
        }
      } else {
        this.editMode = true;
        this.labelButton = window.V.$i18n.t("global.edit");
        if (this.$refs.apForm) {
          this.$refs.apForm.populateForm(node);
        }
      }
    },
  },
  mounted: function () {
    const flag = useDvFlag('beepiz-action-point-can:read');
    if (!flag.access ) {
      if( flag.fallback==="no_plan")
        this.$router.push({ name: 'AccessDenied', params: { slug: "actionpoints-library"} })
      else
        this.$router.push({ name: 'AccessDenied', params: { slug: "actionpoints-library_no_role"} })
    }
    else {
      this.editMode = false;
      this.Ichrome = this.chrome;
      if (this.patrol) {
        this.filter["wifi"] = false;
        this.filter["beacon"] = false;
      }
      if (this.chrome) {
        this.loadList(this.currentPage);
      }
      if (!useDvFlagAccess("beepiz-action-point-can:create")) {
        this.libraryClasses = "col-12 full-height";
      }
    }
  },
  name: "library",
  props: {
    chrome: {
      default: true,
      type: [Boolean],
    },
    planId: {
      default: null,
      type: Number,
    },
    props: {
      default: function () {
        return {};
      },
      type: Object,
    },
    patrol: {
      type: Boolean,
      default: false,
    },
    typeFilter: {
      type: Array,
      default: null,
    },
  },
  watch: {
    chrome: function (newValue) {
      this.Ichrome = newValue;
    },
    planId: function (newValue) {
      this.loadList(this.currentPage);
    },
    props: function (newValue) {
      if (newValue.chrome != null) {
        this.Ichrome = newValue.chrome;
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
